import loadable from '@loadable/component';
import mapSVG from 'comune.imola.voltotheme/icons/map-marked-alt.svg';
import linkSvg from '@plone/volto/icons/link.svg';
import noteSvg from 'bootstrap-italia/src/svg/it-note.svg';
import searchIcon from 'bootstrap-italia/src/svg/it-search.svg';
import indirizzoSvg from 'comune.imola.voltotheme/icons/location-dot.svg';

import MapView from 'comune.imola.voltotheme/components/ImolaTheme/Blocks/Map/View';
import MapEdit from 'comune.imola.voltotheme/components/ImolaTheme/Blocks/Map/Edit';
import SuggerimentiBibliotecaEdit from 'comune.imola.voltotheme/components/ImolaTheme/Blocks/SuggerimentiBiblioteca/Edit';
import SuggerimentiBibliotecaView from 'comune.imola.voltotheme/components/ImolaTheme/Blocks/SuggerimentiBiblioteca/View';
import EventoView from 'design-comuni-plone-theme/components/ItaliaTheme/View/EventoView/EventoView';
import ScopriContenutiView from 'comune.imola.voltotheme/components/ImolaTheme/Blocks/ScopriContenuti/View';
import ScopriContenutiEdit from 'comune.imola.voltotheme/components/ImolaTheme/Blocks/ScopriContenuti/Edit';
import ArgumentListingTemplateReggio from 'comune.imola.voltotheme/components/ImolaTheme/Blocks/Listing/SquareImageListingTemplate';
import ImageGalleryListingBlockTemplate from 'comune.imola.voltotheme/components/ImolaTheme/Blocks/Listing/ImageGallery';
import ImolaDoveTemplate from 'comune.imola.voltotheme/components/ImolaTheme/Blocks/Listing/ImolaDove';
import SearchInCatalogsView from 'comune.imola.voltotheme/components/ImolaTheme/Blocks/SearchInCatalogs/View';
import SearchInCatalogsEdit from 'comune.imola.voltotheme/components/ImolaTheme/Blocks/SearchInCatalogs/Edit';
import { MultilingualWidget } from 'volto-multilingual-widget';
import { ArrayWidget } from '@plone/volto/components';
import IndirizzoView from 'comune.imola.voltotheme/components/ImolaTheme/Views/IndirizzoView/IndirizzoView';

import IndirizzoSearchView from 'comune.imola.voltotheme/components/ImolaTheme/Blocks/IndirizzoSearch/View';
import IndirizzoSearchEdit from 'comune.imola.voltotheme/components/ImolaTheme/Blocks/IndirizzoSearch/Edit';

import { addDefaultOptions } from 'design-comuni-plone-theme/config/Blocks/ListingOptions';

const applyConfig = (config) => {
  config.settings = {
    ...config.settings,

    defaultExcludedFromSearch: {
      portalTypes: ['Image'],
    },

    loadables: {
      ...config.settings.loadables,
      'subsite-bim-style': loadable.lib(() => import('./subsites/bim-style')),
      'subsite-sportelloedilizia': loadable.lib(() =>
        import('./subsites/sportelloedilizia'),
      ),
      'subsite-centrostorico': loadable.lib(() =>
        import('./subsites/centrostorico'),
      ),
      'subsite-scuolaeformazione': loadable.lib(() =>
        import('./subsites/scuolaeformazione'),
      ),
      'subsite-cpo': loadable.lib(() => import('./subsites/cpo')),
    },

    matomoSiteId: 'kJ3ZG1ypLy',
    matomoUrlBase: 'https://ingestion.webanalytics.italia.it/',

    // italiaThemeViewsConfig: {
    //   ...config.settings.italiaThemeViewsConfig,
    //   imagePosition: 'afterHeader', // possible values: afterHeader, documentBody
    // },

    siteProperties: {
      /*
        Per tutte le props di siteProperties, può essere definito un oggetto per i siti multilingua, strutturato in questo modo:
        {'default': _valore_della_prop, 'it': _valore_della_prop,...}
        Se l'oggetto non è strutturato in questo modo, viene usato l'oggetto stesso, altrimenti viene preso il valore della corrispondente alla prop della lingua corrente o alla prop 'default' se esiste.
      */
      ...config.settings.siteProperties,
      siteTitle: 'Comune di Imola',
      siteSubtitle: 'RETE CIVICA',
      parentSiteTitle: 'Nuovo Circondario Imolese',
      parentSiteURL: 'https://www.nuovocircondarioimolese.it/',
      subsiteParentSiteTitle: 'Comune di Imola',
      enableCustomerSatisfaction: false,
    },

    externalRoutes: [
      ...config.settings.externalRoutes,
      // URL to be considered as external
      // { match: '/news' },
      // Rimangono pubblicati nel vecchio sito e devono essere consultabili:
      // /aree-tematiche
      // /come-fare-per
      // /imoladove/
      // /oggetti-ritrovati
      // /prenotazioni-on-line/
      // /scuola-formazione
      // /servizi-online
      // /sportelloedilizia
      // /urp-ufficio-relazioni-con-il-pubblico
      // { match: '/aree-tematiche' },
      // { match: '/come-fare-per' },
      // { match: '/imoladove' },
      // { match: '/oggetti-ritrovati' },
      // { match: '/prenotazioni-on-line' },
      // { match: '/scuola-formazione' },
      // { match: '/servizi-online' },
      // { match: '/sportelloedilizia' },
      // { match: '/urp-ufficio-relazioni-con-il-pubblico' },
    ],

    'volto-gdpr-privacy': {
      ...config.settings['volto-gdpr-privacy'],
      defaultPanelConfig: {
        ...config.settings['volto-gdpr-privacy'].defaultPanelConfig,
        last_updated: '2022-06-20T16:16:00+00:00',
        technical: {
          ...config.settings['volto-gdpr-privacy'].defaultPanelConfig.technical,
          choices: [
            {
              config_key: 'MATOMO',
              text: {
                it: {
                  title: 'Web Analytics Italia',
                  description:
                    "I cookie di Web Analytics Italia sono usati per analizzare la navigazione sul sito al fine di migliorarla e fornire all'utente un'esperienza di navigazione migliore possibile.",
                },
                // en: {
                //   title: 'Web Analytics Italia',
                //   description:
                //     'Web Analytics Italia cookie are used to analyze navigation on the site in order to improve it and provide the user with the best possible browsing experience.',
                // },
                // fr: {
                //   title: 'Web Analytics Italia',
                //   description:
                //     "Les cookie de Web Analytics Italia sont utilisés pour analyser la navigation sur le site afin de l'améliorer et offrir à l'utilisateur la meilleure expérience de navigation possible.",
                // },
              },
            },
            ...config.settings[
              'volto-gdpr-privacy'
            ].defaultPanelConfig.technical.choices.filter(
              (f) => f.config_key !== 'GANALYTICS',
            ),
          ],
        },
      },
    },
    contentIcons: {
      ...config.settings.contentIcons,
      Indirizzo: indirizzoSvg,
    },
  };

  config.views.contentTypesViews.Rassegna = EventoView;

  config.blocks.blocksConfig = {
    ...config.blocks.blocksConfig,
    map: {
      id: 'map',
      title: 'Mappa degli uffici',
      icon: mapSVG,
      group: 'homePage',
      view: MapView,
      edit: MapEdit,
      restricted: false,
      mostUsed: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },
    suggerimenti_biblioteca: {
      id: 'suggerimenti_biblioteca',
      title: 'Cose da fare',
      icon: noteSvg,
      group: 'homePage',
      view: SuggerimentiBibliotecaView,
      edit: SuggerimentiBibliotecaEdit,
      restricted: false,
      mostUsed: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },
    scopriContenuti: {
      id: 'scopriContenuti',
      title: 'Scopri i contenuti',
      icon: linkSvg,
      group: 'homePage',
      view: ScopriContenutiView,
      edit: ScopriContenutiEdit,
      restricted: false,
      mostUsed: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },
    searchInCatalogs: {
      id: 'searchInCatalogs',
      title: 'Cerca nei cataloghi',
      icon: linkSvg,
      group: 'homePage',
      view: SearchInCatalogsView,
      edit: SearchInCatalogsEdit,
      restricted: false,
      mostUsed: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },
    // searchIndirizzo: {
    //   id: 'searchIndirizzo',
    //   title: 'Ricerca Indirizzi',
    //   icon: searchIcon,
    //   group: 'search',
    //   view: IndirizzoSearchView,
    //   edit: IndirizzoSearchEdit,
    //   restricted: false,
    //   mostUsed: false,
    //   // cloneData: cloneBlock,
    //   security: {
    //     addPermission: [],
    //     view: [],
    //   },
    //   sidebarTab: 1,
    // },
    listing: {
      ...config.blocks.blocksConfig.listing,
      templates: {
        ...config.blocks.blocksConfig.listing.templates,
        argumentListingTemplateReggio: {
          label: 'Lista di immagini quadrate',
          template: ArgumentListingTemplateReggio,
        },
        imageGallery: {
          label: 'Image gallery',
          template: ImageGalleryListingBlockTemplate,
        },
      },
      variations: [
        ...config.blocks.blocksConfig.listing.variations,
        {
          id: 'cardIndirizzo',
          isDefault: false,
          title: 'Imola Dove',
          template: ImolaDoveTemplate,
          fullobjects: true,
          schemaEnhancer: ({ schema, formData, intl }) => {
            addDefaultOptions(schema, formData, intl);
            return schema;
          },
        },
      ],
    },
  };
  config.settings.searchBlockTemplates.push('cardIndirizzo');

  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    Indirizzo: IndirizzoView,
  };

  config.widgets = {
    ...config.widgets,
    id: {
      ...config.widgets.id,
      involved_in_disponibili: MultilingualWidget(
        (props) => <ArrayWidget {...props} creatable={true} wrapped={false} />,
        [],
      ),
      recapiti_web_disponibili: MultilingualWidget(
        (props) => <ArrayWidget {...props} creatable={true} wrapped={false} />,
        [],
      ),
    },
  };

  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    Indirizzo: IndirizzoView,
  };

  config.widgets = {
    ...config.widgets,
    id: {
      ...config.widgets.id,
      involved_in_disponibili: MultilingualWidget(
        (props) => <ArrayWidget {...props} creatable={true} wrapped={false} />,
        [],
      ),
      recapiti_web_disponibili: MultilingualWidget(
        (props) => <ArrayWidget {...props} creatable={true} wrapped={false} />,
        [],
      ),
    },
  };

  return config;
};

export default applyConfig;
